import { render, staticRenderFns } from "./staticDataTable.vue?vue&type=template&id=300c30d7&"
import script from "./staticDataTable.vue?vue&type=script&lang=js&"
export * from "./staticDataTable.vue?vue&type=script&lang=js&"
import style0 from "./staticDataTable.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports